import _ from "lodash";
import React from "react";
import { Redirect } from "react-router-dom";
import { LoginLayout } from "../components";
import { LoginForm } from "../features/auth";
import { useUserMe, useCongress } from "../hooks";

const LoginPage = () => {
  const { user } = useUserMe();
  const { congress } = useCongress();
  const redirectMap = {
    accademic: "/my-posters",
    speaker: "/my-presentations",
    admin: "/home"
  };

  const mainRole = user.roles?.[0];
  if (user.loaded) {
    if (_.isEmpty(user.roles)) {
      return <Redirect to="/home" />;
    }

    const defaultRedirect = congress?.open ? "/home" : "/profile";
    return <Redirect to={redirectMap[mainRole] || defaultRedirect} />;
  }

  return (
    <LoginLayout>
      <LoginForm />
    </LoginLayout>
  );
};
export default LoginPage;
